/*
 * Copyright (c) Arbeidskracht Groep B.V. - all rights reserved
 */

export const red = '#d9534f';
export const white = '#fff';
export const blue = '#337ab7';
